import { default as _ } from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { CaisServiceService } from '../../cais-service.service';
import { CaisExceptionServiceService } from '../../exceptions/cais-exception-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NgClass, LowerCasePipe,CommonModule, SlicePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import {MatListItem} from '@angular/material/list';
import { ErrorCodeDetailsComponent } from '../error-code-details/error-code-details.component';
import { RecordDetailsComponent } from '../record-details/record-details.component';
import { DialogModule } from 'primeng/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { TabsModule } from 'primeng/tabs';
import { DatePickerModule } from 'primeng/datepicker';
@Component({
    selector: 'app-view',
    imports: [NgClass, CommonModule, ButtonModule, MatTooltipModule,
        MatProgressSpinner, LowerCasePipe, ConfirmDialogModule, FormsModule,
        TableModule, TabsModule, SlicePipe, RecordDetailsComponent,
        ErrorCodeDetailsComponent, DialogModule, MatDividerModule, MatListItem, DatePickerModule
    ],
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
  @Input('rowDataforDialog') rowDataforDialog: any;
  @Input('screenType') screenType: any;
  @Input('showRecordDetails') showRecordDetails: any = true;
  @Input('activeRecordType') activeRecordType: any = "MASTER";

  isViewLoadingResults = false;

  countryList: any = [];
  countryRegionList: any = [];

  addScreenNegotiatedFields: Array<string>;
  editScreenNegotiatedFields: Array<string>;
  viewScreenNegotiatedFields: Array<string>;
  CommonNegotiatedFields: Array<string>;
  DisabledFields: Array<string>;
  editDisabledFields: Array<string>;
  ExceptionalFDIDScreenFields: Array<string>;
  CountryFields: Array<string>;

  addressColumns: any = [];
  addressColumnJson: any = [];
  NaturalPersoncols: any = [];
  LegalEntitycols: any = [];
  TIDcols: any = [];
  LTIDcols: any = [];
  ExceptionCodeDetailsCols: any = [];

  LTIDDataSet: any = [];
  yearField: any = "0000";
  FDIDScreenDataDetails: any = [];
  FDIDAddressDetails: any = [];
  NaturalPersonDataDetails: any = [];
  LegalEntityDataDetails: any = [];
  AddressDetails: any = [];
  NaturalPersonAddressDetails: any = [];
  LegalEntityAddressDetails: any = [];
  fdidScreenDataDetails: any = [];
  NaturalPersonScreenDataDetails: any = [];
  LegalEntityScreenDataDetails: any = [];
  LTIDScreenDataDetails: any = [];
  TIDScreenDataDetails: any = [];

  ExceptionCodesDetails: any=[];

  NaturalPersons!: any[];
  LegalEntities!: any[];
  tbldatamsg!: string;
  selectedTabIndex: number = 0;



  constructor(public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService: CaisServiceService,
    private messageService: MessageService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlService: UrlsService,
    private userService: UserService
  ) {
    this.addScreenNegotiatedFields = this.caisServiceService.addScreenNegotiatedFields;
    this.editScreenNegotiatedFields = this.caisServiceService.editScreenNegotiatedFields;
    this.viewScreenNegotiatedFields = this.caisServiceService.viewScreenNegotiatedFields;
    this.CommonNegotiatedFields = this.caisServiceService.CommonNegotiatedFields;
    this.DisabledFields = this.caisServiceService.DisabledFields;
    this.editDisabledFields = this.caisServiceService.editDisabledFields;
    this.ExceptionalFDIDScreenFields = this.caisServiceService.ExceptionalFDIDScreenFields;
    this.CountryFields = this.caisServiceService.CountryFields;
    this.rowDataforDialog = this.caisExceptionServiceService.rowDataforDialog;
    this.getColumns();
    this.caisServiceService.getScreenData(this.rowDataforDialog);
    this.updateFileds();
  }

  getColumns() {
    this.caisServiceService.getColumns();
    this.addressColumnJson = this.caisServiceService.addressColumnJson;
    this.addressColumns = this.caisServiceService.addressColumns;
    this.NaturalPersoncols = this.caisServiceService.NaturalPersoncols;
    this.LegalEntitycols = this.caisServiceService.LegalEntitycols;
    this.LTIDcols = this.caisServiceService.LTIDcols;
    this.TIDcols = this.caisServiceService.TIDcols;
    this.ExceptionCodeDetailsCols = this.caisExceptionServiceService.exceptionDetailsColumns;
  }

  ngOnInit() {
    this.getExceptionView();
  }

  getExceptionView() {
    let firmDesignatedID = this.rowDataforDialog["firmDesignatedID"];
    let accountNumber = this.rowDataforDialog["accountNumber"];
    let receivedFDID = this.rowDataforDialog["receivedFDID"];
    if(firmDesignatedID && (!receivedFDID || receivedFDID.length == 0)){
      receivedFDID = firmDesignatedID;
    }
    if (firmDesignatedID || accountNumber || receivedFDID) {
      /* FDID View Detail */
      this.FDIDScreenDataDetails = [];
      this.FDIDAddressDetails = [];
      this.LTIDDataSet = [];
      this.NaturalPersons = [];
      this.LegalEntities = [];
      this.NaturalPersonDataDetails = [];
      this.NaturalPersonAddressDetails = [];
      this.LegalEntityDataDetails = [];
      this.LegalEntityAddressDetails = [];
      this.ExceptionCodesDetails = [];
      this.isViewLoadingResults = true;
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          APIURL.CAIS_Exception_View
        ), {
        type: this.activeRecordType,
        source: this.rowDataforDialog["source"],
        CATReporterIMID: this.userService.getActiveMPID(),
        firmDesignatedID: firmDesignatedID,
        accountNumber: accountNumber,
        reportDate: this.rowDataforDialog["reportDate"],
        receivedFDID: ((!receivedFDID || receivedFDID.length == 0) ? receivedFDID : firmDesignatedID),
        customerRecordID: this.rowDataforDialog["customerRecordID"],
        inCustomerRecordID: this.rowDataforDialog["inCustomerRecordID"],
        user: this.userService.getUserName(),
        userName: this.userService.getUserFirstName()
      }
      ).subscribe({
        next: (element:any) => {
        let dataset: any = element;
        this.tbldatamsg = "No data found";
        let exceptionList: any;
        this.isViewLoadingResults = false;
        if (dataset) {
          if (dataset.fdidDetails !== null) {
            this.FDIDScreenDataDetails = this.caisServiceService.loadFDIDDetails(dataset.fdidDetails, this.rowDataforDialog);
          }
          let tabIndex = 0;
          this.FDIDAddressDetails = this.caisServiceService.loadFDIDAddress(dataset.fdidAddrDetails);
          this.LTIDDataSet = this.caisServiceService.loadLTIDDetails(dataset.ltidDetails)
          this.NaturalPersons = this.caisServiceService.loadTabNameArray(dataset.naturalPersonDetails, "Add Natural Person",tabIndex);
          this.NaturalPersonDataDetails = this.caisServiceService.loadNaturalPersonDetails(dataset.naturalPersonDetails);
          this.NaturalPersonAddressDetails = this.caisServiceService.prepareAddress(dataset.naturalPersonDetails);
          this.LegalEntities = this.caisServiceService.loadTabNameArray(dataset.legalEntityDetails, "Add Legal Entity",this.NaturalPersons.length);
          this.LegalEntityDataDetails = this.caisServiceService.loadLegalEntityDetails(dataset.legalEntityDetails);
          this.LegalEntityAddressDetails = this.caisServiceService.prepareAddress(dataset.legalEntityDetails);
          this.ExceptionCodesDetails = dataset.exceptionList;
        }
          this.selectedTabIndex = (this.LegalEntities.length > 1 ? this.LegalEntities[1]['tabIndex'] : 0);
          if (this.selectedTabIndex == 0) {
            this.selectedTabIndex = (this.NaturalPersons.length > 1 ? this.NaturalPersons[1]['tabIndex'] : 0);
          }
      },
      error: (err: HttpErrorResponse) => {
        this.isViewLoadingResults = false;
      }
    });
    }else{
      this.ExceptionCodesDetails[0]={failureCode: this.rowDataforDialog['failureCode'], failureDescription: this.rowDataforDialog['failureDescription']};
    }
  }


  updateFileds() {
    this.fdidScreenDataDetails = this.caisServiceService.fdidScreenDataDetails;
    this.addressColumns = this.caisServiceService.addressColumns;
    this.NaturalPersonScreenDataDetails = this.caisServiceService.NaturalPersonScreenDataDetails;
    this.LegalEntityScreenDataDetails = this.caisServiceService.LegalEntityScreenDataDetails;
    this.LTIDScreenDataDetails = this.caisServiceService.LTIDScreenDataDetails;
    this.addressColumnJson = this.caisServiceService.addressColumnJson;
    this.AddressDetails = this.caisServiceService.AddressDetails;

  }
}